<template>
  <v-layout row justify-center>
    <v-dialog v-model="visible" fullscreen hide-overlay 
      transition="dialog-bottom-transition" 
      content-class="e-diccionario e-texto">
      <v-card style="background-color: #fafafa" class="pb-3">
        <div class="e-diccionario-content">
          <v-btn icon @click="close" class="e-diccionario-close">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <CardLectura
        :image="imageUnidad ? require('@/assets/images/unit/practice/' + imageUnidad) : image"
        :textKr="textKr"
        :textEs="textEs"
        />
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import CardLectura from '../intermedio/CardLectura'
export default {
  name: 'CardTextoFinal',
  props: {
    image: {
      type: String,
      default: require('@/assets/images/practica/image-lectura.png')
    },
    imageUnidad: {
      type: String,
      default: ''
    },
    textEs: {
      type: String,
      default: 'Mi nombre es Nicole. Yo trabajo en la cafetería. Ahora es la una y media de la tarde, yo estoy esperando un hombre hoy también. Su nombre es Camilo. Él siempre toma el cafe despúes de comer el almuerzo. Esa hora es la una y media de la tarde. Camilo tiene una cara guapa, unos ojos bonitos y su voz baja y blanda. Cuando hablé con Camilo la primera vez, mi corazón palpitaba mucho mucho. Él siempre dice “Gracias.” depués de recibir el recibo. Camilo mira mis ojos y lo dice. Yo no respondo y solamente río. Sinceramente, yo todavía no puedo responder. Yo no puedo responder porque me averguenzo mucho raramente, no puedo ver los ojos bonitos de Camilo. Yo... tengo un amor secreto por esa persona.¿Qué hago? Yo quiero andar con Camilo. ¿Qué tengo que hacer?'
    },
    textKr: {
      type: String,
      default: '이 택시의 이름은<span class="primary--text">이별택시예요.</span>  사람들이 이별을 원할 때 이 택시를 타요. 그들은 택시에서 이별을 한 다음에 내려요. 오늘 저녁 7시에 어떤 아저씨의 예약이 있어요. 그의 이름은 페드로예요. 이제 택시가 도착했어요. 페드로, 그의 옆에 어떤 여자가 있었어요. 페드로의 아내, 로시오예요. 페드로는 이별 택시가 출발한 다음에 로시오와 이별을 시작했어요. 페드로는 년 전에 암에 걸렸어요. 그런데 그는 3주 전에 병원에서 어떤 5사실을 알았어요. 페드로는 세 달만 살 수 있어요. 그는 세 달 후에 죽을 거예요. 의사가 그렇게 말했어요. 페드로는 로시오에게 말했어요.“나는 병원에만 있어야 돼요. 우리 6헤어져요. 나는 당신에게 괴로움을 주고 싶지 않아요. 로시오, 당신은 아직 7젊어요. 그리고 8미래가 있어요. 다시 시작할 수 있어요.” 페드로는 조용히 울고 있었어요.“미안해요, 정말 미안해요. 나는.. 정말... 미안해요.”그는 로시오의 가슴에 9얼굴을 묻고 계속 울었어요. 로시오는 페드로를 안아 줬어요. 그리고 말했어요. “그렇게 말하지 마세요. 나는 항상 당신 옆에 있을 거예요. 기억해요? 내가 열 일곱 살 때, 꿈도, 희망도 없어서 죽으려고 했어요. 집의 10빚, 동생의 사고, 아버지하고 마약... 정말 죽고 싶었어요. 그런데 페드로, 당신은 나를 11지켜 줬어요. 나를 위해 많은 12희생을 했어요. 이제 내가 당신을 지켜 줄게요. 나는 다른 13소원은 없어요. 그냥 당신보다 하루만 더 살고 싶어요.”로시오는 조용히 미소 지었어요. 그리고 이별택시는 14계속 가고 싶었어요. 이별 택시는 두 사람의 이별을 위해 멈춰야 돼요. 하지만 이별 택시는 이상하게 15멈추고 싶지 않았어요. 아니, 이별 택시는 멈출 수 없었어요.'
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      ui: state => state.ui
    })
  },
  components: {
    CardLectura
  },
  methods: {
    close(){
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-dialog__content.v-dialog__content--active {
  background-color: rgba(0,0,0,0.3);
}
.e-diccionario-content {
    position: fixed;
    z-index: 10;
}
</style>